<template>
  <div>
    <section v-if="type === 'motor'">
      <order-header title="Motor, volume en tank"/>
      <order-item v-if="motor" :title="motorTitle" :price="motor.price"/>
      <order-item v-if="pump" :title="pump.cc + ' cc pomp'" :price="pump.price"/>
      <order-item v-if="tank" :title="tank.liters + ' liter tank'" :price="tank.price"/>
      <order-item v-if="circuit" :title="circuit.name.nl + ' ' + valveType + ' circuit'" :price="circuit.price"/>

      <order-item v-for="(option, i) in options" :title="option.name" :price="option.price" :key="i"/>
    </section>
    <section v-if="type === 'cilinder'">
      <order-header title="Cilinder"/>
      <order-item v-if="selectedCilinder" :title="cilinder.name" :price="cilinder.price"/>
<!--      <order-item v-for="(option, i) in options" :title="option.name" :price="option.price" :key="i"/>-->
    </section>
  </div>
</template>

<script>
import OrderHeader from "./items/OrderHeader";
import OrderItem from "./items/OrderItem";
import {mapGetters, mapState} from "vuex";
import orderMixin from "../../../mixins/orderMixin";

export default {
  name: "OrderBase",
  props: {
    motor: {
      type: Object,
      default: () => {
        return {kw: 0, rpm: 0, price: 0}
      }
    },
    tank: {
      type: Object,
      default: () => {
        return {liters: 0, price: 0}
      }
    },
    pump: {
      type: Object,
      default: () => {
        return {cc: 0, price: 0}
      }
    },
    cilinder: {
      type: Object,
      default: () => {
        return {price: 0}
      }
    },
    type: {
      type: String,
      default: '',
    }
  },
  components: {
    OrderHeader,
    OrderItem
  },

  computed: {
    ...mapState({
      pressure: state => state.preference.pressure,
      stateValveType: state => state.build.valveType,
      selectedCilinder: state => state.preference.selectedCilinder
    }),
    ...mapGetters({
      circuit: 'build/getCircuit',
      maxPressure: 'build/maxPressure',
      cilinder: 'preference/getSelectedCilinder'
    }),
    options() {
      let array = [];

      switch (this.type) {
        case 'mini_powerpack':
          const pressure = [
            {
              name: 'Maximale drukveiligheid ' + this.maxPressure + ' bar',
              selected: true,
            }
          ];

          if (this.throttle !== 'no' && this.valveType === 1) {
            pressure.push({
              name: 'Retoursmoring: ' + this.throttle,
              selected: true,
            })
          }

          array = pressure.concat(this.powerpackOptions);
          break;
        case 'workplace':
          if (this.electricalBox) {
            const {name, price} = this.electricalBox;
            array.push({
              name: this.translate(name),
              price: price,
              selected: true,
            })
          }

          if (this.oilCooler) {
            const {name, price} = this.oilCooler;
            array.push({
              name: this.translate(name),
              price: price,
              selected: true,
            })
          }

          array = array.concat(this.workplaceOptions);
          break;
        case 'frame':
          array = this.frameOptions;
          break;
      }

      return array.filter(option => {
        return option.selected;
      });
    },
    motorTitle() {
      const m = this.motor;
      let title = '';

      if (m.type === 'electric') {
        title += 'Elektrische motor ' + m.voltage + ' ' + m.current.toUpperCase();
      } else if (m.fuel_type === 'benzine') {
        title += 'Benzine motor ' + m.pk + ' PK';
      } else if (m.fuel_type === 'diesel') {
        title += 'Diesel motor ' + m.pk + ' PK';
      }

      return title;
    },
    valveType() {
      if (this.stateValveType === 1) {
        return 'Enkelwerkend'
      }

      return 'Dubbelwerkend';
    },
  }
}
</script>
